import React from 'react';

const ArrowRightIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="13" viewBox="0 0 21 13" fill="none" stroke="currentColor" {...rest}>
      <path d="M13.4 1L19 6.5M19 6.5L13.4 12M19 6.5L1.66694e-06 6.5"  strokeWidth="1.6"/>
    </svg>
  );
};

export default ArrowRightIcon;